// extracted by mini-css-extract-plugin
module.exports = {"container":"a2c79c7e7d--container--lDwy9","scroll":"a2c79c7e7d--scroll--f7LMl","arrow":"a2c79c7e7d--arrow--y05Rn"};